import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "Which types of scrap materials do you deal in?",
      answer:
        "We deal in Iron Scrap, Copper Scrap, and Aluminium Scrap in bulk quantities for industrial and commercial requirements.",
    },
    {
      question: "How much scrap can you supply in a single day?",
      answer:
        "We can supply up to 5 tons of scrap material per day depending on stock availability and client requirements.",
    },
    {
      question: "Do you provide services across India?",
      answer:
        "Currently, our operations are focused on Delhi NCR and nearby regions to ensure fast and reliable service.",
    },
    {
      question: "Do you buy scrap as well as sell scrap?",
      answer:
        "Yes, we purchase and supply Iron, Copper, and Aluminium scrap in bulk quantities.",
    },
    {
      question: "How can I get the latest scrap prices?",
      answer:
        "You can contact our team directly or submit an inquiry through the website to receive current market rates.",
    },
    {
      question: "Can I place a bulk order for industrial requirements?",
      answer:
        "Absolutely. We specialize in fulfilling bulk orders for factories, recyclers, traders, and industrial clients.",
    },
    {
      question: "How can I request a quotation?",
      answer:
        "Simply click on the Get Quote button or contact us via phone, email, or inquiry form.",
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      <style>{`
.faq-section{
  padding:90px 5%;
  background:linear-gradient(135deg,#f8fbff,#eef5ff);
  overflow:hidden;
}

/* =========================
   HEADING
========================= */

.faq-heading{
  text-align:center;
  margin-bottom:60px;
}

.faq-heading h2{
  font-size:42px;
  color:#0B2E7A;
  font-weight:800;
  margin-bottom:15px;
  position:relative;
  display:inline-block;
  cursor:pointer;
  transition:.3s;
}

.faq-heading h2:hover{
  transform:translateY(-3px);
}

.faq-heading h2::after{
  content:"";
  position:absolute;
  left:50%;
  bottom:-12px;
  transform:translateX(-50%);
  width:90px;
  height:4px;
  background:#FFD400;
  border-radius:10px;
  transition:.4s;
}

.faq-heading h2:hover::after{
  width:220px;
}

.faq-subtitle{
  color:#666;
  max-width:700px;
  margin:auto;
  font-size:16px;
  line-height:1.8;
}

/* =========================
   CONTAINER
========================= */

.faq-container{
  max-width:1000px;
  margin:auto;
}

/* =========================
   CARD
========================= */

.faq-card{
  background:rgba(255,255,255,.95);
  backdrop-filter:blur(12px);
  border-radius:18px;
  margin-bottom:20px;
  overflow:hidden;
  border-left:5px solid transparent;
  box-shadow:0 10px 30px rgba(0,0,0,.08);
  transition:.35s;
}

.faq-card:hover{
  transform:translateY(-5px);
  border-left:5px solid #FFD400;
  box-shadow:0 15px 40px rgba(11,46,122,.15);
}

/* =========================
   QUESTION
========================= */

.faq-question{
  display:flex;
  justify-content:space-between;
  align-items:center;
  padding:24px;
  cursor:pointer;
  transition:.35s;
}

.faq-question.active{
  background:#0B2E7A;
  color:#fff;
}

.faq-question:hover{
  background:#0B2E7A;
  color:#fff;
}

.faq-left{
  display:flex;
  align-items:center;
  gap:18px;
  flex:1;
}

.faq-number{
  width:50px;
  height:50px;
  min-width:50px;
  border-radius:50%;
  background:#FFD400;
  color:#0B2E7A;
  font-size:18px;
  font-weight:700;
  display:flex;
  align-items:center;
  justify-content:center;
}

.faq-text{
  font-size:18px;
  font-weight:600;
  line-height:1.5;
}

.faq-icon{
  transition:.35s;
  flex-shrink:0;
}

.faq-icon.rotate{
  transform:rotate(180deg);
}

/* =========================
   ANSWER
========================= */

.faq-answer{
  padding:0 24px 24px 92px;
  background:#fff;
  color:#555;
  line-height:1.9;
  font-size:15px;
  animation:slideDown .35s ease;
}

@keyframes slideDown{

  from{
    opacity:0;
    transform:translateY(-10px);
  }

  to{
    opacity:1;
    transform:translateY(0);
  }

}

/* =========================
   TABLET
========================= */

@media (max-width:992px){

  .faq-section{
    padding:70px 20px;
  }

  .faq-heading h2{
    font-size:36px;
  }

  .faq-subtitle{
    font-size:15px;
    padding:0 10px;
  }

  .faq-question{
    padding:20px;
  }

  .faq-number{
    width:46px;
    height:46px;
    min-width:46px;
    font-size:17px;
  }

  .faq-text{
    font-size:17px;
  }

  .faq-answer{
    padding:0 20px 20px 82px;
  }

}

/* =========================
   MOBILE
========================= */

@media (max-width:768px){

  .faq-section{
    padding:55px 15px;
  }

  .faq-heading{
    margin-bottom:40px;
  }

  .faq-heading h2{
    font-size:30px;
  }

  .faq-heading h2:hover::after{
    width:120px;
  }

  .faq-subtitle{
    font-size:14px;
    line-height:1.7;
  }

  .faq-question{
    padding:18px;
    align-items:flex-start;
  }

  .faq-left{
    gap:12px;
  }

  .faq-number{
    width:42px;
    height:42px;
    min-width:42px;
    font-size:15px;
  }

  .faq-text{
    font-size:15px;
    line-height:1.5;
  }

  .faq-answer{
    padding:0 18px 18px 18px;
    font-size:14px;
    line-height:1.8;
  }

}

/* =========================
   SMALL MOBILE
========================= */

@media (max-width:480px){

  .faq-section{
    padding:45px 12px;
  }

  .faq-heading h2{
    font-size:26px;
  }

  .faq-heading h2::after{
    width:70px;
  }

  .faq-heading h2:hover::after{
    width:100px;
  }

  .faq-question{
    padding:15px;
  }

  .faq-left{
    gap:10px;
  }

  .faq-number{
    width:38px;
    height:38px;
    min-width:38px;
    font-size:14px;
  }

  .faq-text{
    font-size:14px;
  }

  .faq-answer{
    padding:0 15px 15px 15px;
    font-size:13px;
  }

}
`}</style>

      <section className="faq-section">
        <div className="faq-heading">
          <h2>Frequently Asked Questions</h2>

          <p className="faq-subtitle">
            Find answers to the most common questions about our scrap buying,
            selling, pricing, and bulk supply services.
          </p>
        </div>

        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div className="faq-card" key={index}>
              <div
                className={`faq-question ${
                  activeIndex === index ? "active" : ""
                }`}
                onClick={() => toggleFAQ(index)}
              >
                <div className="faq-left">
                  <div className="faq-number">
                    {String(index + 1).padStart(2, "0")}
                  </div>

                  <div className="faq-text">
                    {faq.question}
                  </div>
                </div>

                <ChevronDown
                  size={24}
                  className={`faq-icon ${
                    activeIndex === index ? "rotate" : ""
                  }`}
                />
              </div>

              {activeIndex === index && (
                <div className="faq-answer">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default FAQ;